import { apiClient } from "services/api-client";

export const getAsmAssetPaged = async (slug, page, perPage) => {
  return await apiClient.get(`/asm/asset-paged?org=${slug}&page=${page}&perPage=${perPage}`)
}

export const getAsmCertPaged = async (slug, page, perPage) => {
  return await apiClient.get(`/asm/cert-paged?org=${slug}&page=${page}&perPage=${perPage}`)
}

export const getAsmVulnerabilityPaged = async (slug, page, perPage) => {
  return await apiClient.get(`/asm/vulnerability-paged?org=${slug}&page=${page}&perPage=${perPage}`)
}

export const getCdnList = async (slug) => {
  return await apiClient.get(`/asm/cdn-list/${slug}`)
}

export const getWafList = async (slug) => {
  return await apiClient.get(`/asm/waf-list/${slug}`)
}

export const getCertList = async (slug) => {
  return await apiClient.get(`/asm/cert-list/${slug}`)
}

export const getCertCounter = async (slug) => {
  return await apiClient.get(`/asm/cert-counter/${slug}`)
}

export const getSeverityList = async (slug) => {
  return await apiClient.get(`/asm/severity-list/${slug}`)
}

export const getVulnerabilityList = async (slug) => {
  return await apiClient.get(`/asm/vulnerability-list/${slug}`)
}

export const getVulnerabilityCounter = async (slug) => {
  return await apiClient.get(`/asm/vulnerability-counter/${slug}`)
}

export const canScan = async (slug) => {
  return await apiClient.get(`/asm/can-scan/${slug}`)
}

export const scanBySlug = async (slug) => {
  const data = {
    tenant: slug,
  }
  return await apiClient.post(`/asm/scan/`, data)
}

export const getAsmMetrics = async (companyKey) => {
  return await apiClient.get(`/asm/metrics?companyKey=${companyKey}`)
}